export default __webpack_public_path__ + "static/logo3.e4850ac220e7d8d67cd07302c68a627b.png";